import {
  PaRoutineDeleteDataSchema,
  PaRoutineListDataSchema,
  PaRoutineResponseSchema,
  PaRoutineRunDecisionDataSchema,
  PaRoutineRunConfirmBodySchema,
  PaRoutineRunDetailSchema,
  PaRoutineRunListDataSchema,
  PaRoutineRunStartDataSchema,
  PaRoutineScheduleUpdateBodySchema,
  type PaRoutine,
  type PaRoutineRunConfirmBody,
  type PaRoutineRunDetail,
  type PaRoutineRunListData,
  type PaRoutineRunStatus,
  type PaRoutineScheduleUpdateBody,
} from '@easyflow/shared';
import apiClient from '@/lib/api';

function parseData<T>(schema: { parse(value: unknown): T }, value: unknown): T {
  return schema.parse(value);
}

export async function listRoutines(): Promise<PaRoutine[]> {
  const response = await apiClient.get('/pa-routines');
  return parseData(PaRoutineListDataSchema, response.data);
}

export async function startRoutine(routineId: string): Promise<string> {
  const response = await apiClient.post(`/pa-routines/${routineId}/run`);
  return parseData(PaRoutineRunStartDataSchema, response.data).run_id;
}

export async function setRoutineActive(routineId: string, active: boolean): Promise<PaRoutine> {
  const response = await apiClient.post(`/pa-routines/${routineId}/${active ? 'resume' : 'pause'}`);
  return parseData(PaRoutineResponseSchema.shape.data, response.data);
}

export async function deleteRoutine(routineId: string): Promise<void> {
  const response = await apiClient.delete(`/pa-routines/${routineId}`);
  parseData(PaRoutineDeleteDataSchema, response.data);
}

export async function updateRoutineSchedule(
  routineId: string,
  body: PaRoutineScheduleUpdateBody,
): Promise<PaRoutine> {
  const response = await apiClient.patch(
    `/pa-routines/${routineId}/schedule`,
    PaRoutineScheduleUpdateBodySchema.parse(body),
  );
  return parseData(PaRoutineResponseSchema.shape.data, response.data);
}

export async function listRoutineRuns(
  routineId: string,
  limit = 30,
  offset = 0,
  status?: PaRoutineRunStatus,
): Promise<PaRoutineRunListData> {
  const statusQuery = status ? `&status=${status}` : '';
  const response = await apiClient.get(`/pa-routines/${routineId}/runs?limit=${limit}&offset=${offset}${statusQuery}`);
  return parseData(PaRoutineRunListDataSchema, response.data);
}

export async function getRoutineRun(routineId: string, runId: string): Promise<PaRoutineRunDetail> {
  const response = await apiClient.get(`/pa-routines/${routineId}/runs/${runId}`);
  return parseData(PaRoutineRunDetailSchema, response.data);
}

export async function decideRoutineRun(
  routineId: string,
  runId: string,
  body: PaRoutineRunConfirmBody,
): Promise<void> {
  const response = await apiClient.post(
    `/pa-routines/${routineId}/runs/${runId}/confirm`,
    PaRoutineRunConfirmBodySchema.parse(body),
  );
  parseData(PaRoutineRunDecisionDataSchema, response.data);
}